import { render, staticRenderFns } from "./KezConfirmModal.vue?vue&type=template&id=6c4f6a08&"
import script from "./KezConfirmModal.vue?vue&type=script&lang=js&"
export * from "./KezConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KezConfirmModal.vue"
export default component.exports